// Cells whose first character is one of these are interpreted as formulas
// by Excel / Google Sheets / LibreOffice. Prepending a single apostrophe
// neutralizes them without modifying display elsewhere.
const FORMULA_PREFIX_CHARS = ["=", "+", "-", "@", "\t", "\r"];

export const escapeCsvCell = (value) => {
  if (value == null) return value;
  if (typeof value !== "string") return value;
  if (value.length === 0) return value;
  return FORMULA_PREFIX_CHARS.includes(value[0]) ? `'${value}` : value;
};

// Inverse of escapeCsvCell for round-tripping downloaded files: the guard
// apostrophe is stripped only when the character after it is one that
// escapeCsvCell guards, so values with a genuine leading apostrophe survive.
export const unescapeCsvCell = (value) => {
  if (typeof value !== "string") return value;
  if (value[0] !== "'") return value;
  return FORMULA_PREFIX_CHARS.includes(value[1]) ? value.slice(1) : value;
};

export const sanitizeCsvRows = (rows) =>
  rows.map((row) => {
    const out = {};
    for (const key of Object.keys(row)) out[key] = escapeCsvCell(row[key]);
    return out;
  });
